'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = IconWithText;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypesElementtype = require('prop-types-elementtype');

var _propTypesElementtype2 = _interopRequireDefault(_propTypesElementtype);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _Box = require('@deliveroo/icon-set/react/Box');

var _Box2 = _interopRequireDefault(_Box);

var _mergeProps = require('../../utils/mergeProps');

var _mergeProps2 = _interopRequireDefault(_mergeProps);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Text = require('../../internal/Text');

var _Text2 = _interopRequireDefault(_Text);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  'wrapper': 'ccl-c7e8470a1e905a95',
  'placeholder': 'ccl-b67a3660dda257ef'
};


var GAP_SIZES = ['x-small', 'small'];
var SIZES = ['regular', 'small'];
var COLORS = ['black', 'green', 'grey', 'light-grey', 'orange', 'red', 'teal', 'white'];

/**
 * An icon with text, in the same colour.
 */
function IconWithText(originalProps) {
  var isPlaceholder = originalProps.isPlaceholder;

  var props = isPlaceholder ? (0, _mergeProps2.default)(originalProps, IconWithText.placeholderProps) : originalProps;
  var component = props.component,
      color = props.color,
      children = props.children,
      size = props.size,
      gap = props.gap,
      spacing = props.spacing,
      adjacentVerticalSpacing = props.adjacentVerticalSpacing,
      adjacentHorizontalSpacing = props.adjacentHorizontalSpacing;


  var iconSize = size === 'small' ? 18 : 24;

  return _react2.default.createElement(
    _SpacerElement2.default,
    {
      element: 'span',
      spacing: spacing,
      className: styles.wrapper,
      adjacentVerticalSpacing: adjacentVerticalSpacing,
      adjacentHorizontalSpacing: adjacentHorizontalSpacing,
      isPlaceholder: isPlaceholder,
      placeholderClassName: styles.placeholder
    },
    _react2.default.createElement(_Icon2.default, { size: iconSize, component: component, color: color }),
    _react2.default.createElement(
      _Text2.default,
      { element: 'span', color: color, size: size, adjacentHorizontalSpacing: gap, isAutoHeight: true },
      children
    )
  );
}

IconWithText.displayName = 'IconWithText';
IconWithText.propTypes = _extends({
  /**
   * The icon component you'd like to render, taken from icon-set.
   */
  component: (0, _reactProptypeConditionalRequire2.default)(_propTypesElementtype2.default, function (props) {
    return !props.isPlaceholder;
  }),

  /**
   * An explicit icon colour, overriding the inherited parent colour.
   */
  color: _propTypes2.default.oneOf(COLORS),

  /**
   * Child text
   */
  children: _propTypes2.default.node,

  /**
   * Size of the text and accompanying icon.
   */
  size: _propTypes2.default.oneOf(SIZES),

  /**
   * Size of the gap between the icon and text.
   */
  gap: _propTypes2.default.oneOf(GAP_SIZES)

}, _SpacerElement2.default.propTypes);

IconWithText.defaultProps = _extends({
  color: undefined,
  children: undefined,
  size: 'regular',
  gap: 'x-small'
}, _SpacerElement2.default.defaultProps);

IconWithText.placeholderProps = {
  size: 'regular',
  component: _Box2.default
};